import DoAPICall from './DoAPICall'


export async function getSurveyResponsesOfQuestion(userToken,params){
	const apiPayload = {
		httpMethod:'get',
		userToken,
		uri:'surveyresponsesofquestion?survey_question_id='+params.survey_question_id+'&survey_id='+params.survey_id+
																				'&dateFrom='+params.from+'&dateTo='+params.to,
		payLoad:{},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}
